// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2xMeT","box":"WorkspacesBox_box__3pDFc","node":"WorkspacesBox_node__2ONUu"};